<template>
    <div class="guide_main">
        <div class="block_title text-center">
            <h4 class="mb-0 font-active">Your Guide To Buying The Perfect Engagement Ring</h4>
            <p class="my-4">
                Getting the perfect engagement ring for her, the one that she desires is fairly simple. <br>
                Follow the steps mentioned below to create her lab grown diamond engagement ring.
            </p>
        </div>
        <div class="guide_block">
            <div class="guide_box">
                <NuxtLink :to="localePath('/engagement-ring-guide/ring-cost')" class="text-center">
                    <img loading="lazy" v-if="$country.is_india" alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/budget_india.svg">
                    <img loading="lazy" v-else alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/budget.svg">
                    <h3 class="mb-0">Set A Budget</h3>
                    <p class="mb-0">While there is something to fit in everyone’s budget, planning your investment before buying your ring is always wise.</p>
                </NuxtLink>
            </div>
            <div class="guide_box">
                <NuxtLink :to="localePath('/engagement-ring-guide/types-of-ring-settings')" class="text-center">
                    <img loading="lazy" alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/setting.svg">
                    <h3 class="mb-0">Choose A Setting</h3>
                    <p class="mb-0">Choose from various settings and styles, ranging from halos and solitaires to three stones and vintage. </p>
                </NuxtLink>
            </div>
            <div class="guide_box">
                <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')" class="text-center">
                    <img loading="lazy" alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/diamond.svg">
                    <h3 class="mb-0">Choose A Diamond</h3>
                    <p v-if="$country.is_india" class="mb-0">
                        Pick a lab diamond
                        based on the 4 C's, i.e. Cut, Colour, Clarity, and Carat.
                    </p>
                    <p v-else class="mb-0">Pick a lab diamond based on the 4C’s i.e. Cut, Color, Clarity, and Carat.</p>
                </NuxtLink>
            </div>
            <div class="guide_box">
                <NuxtLink :to="localePath('/engagement-ring-guide/complete-the-ring')" class="text-center">
                    <img loading="lazy" alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/complete.svg">
                    <h3 class="mb-0">Complete Your Ring</h3>
                    <p v-if="$country.is_india" class="mb-0">Choose your ring size and {{ $t('customize') }} it with an engraving according to your preference.</p>
                    <p v-else class="mb-0">Choose your ring size and {{ $t('customize') }} it with an engraving according to your preference. </p>
                </NuxtLink>
            </div>
            <div class="guide_box">
                <NuxtLink :to="localePath('/engagement-ring-guide/time-to-propose')" class="text-center">
                    <img loading="lazy" alt="Set A Budget" width="48" height="48" src="~/assets/landing/engagement/guide/propose.svg">
                    <h3 class="mb-0">Time To Propose</h3>
                    <p class="mb-0" v-if="$country.is_india">Plan the perfect proposal for your partner and make her say ‘I DO’ with a Friendly Diamonds' engagement ring! </p>
                    <p class="mb-0" v-else>Plan the perfect proposal for your partner and make her say <b>‘I DO’</b> with a Friendly Diamonds' engagement ring!</p>
                </NuxtLink>
            </div>
        </div>
        <div class="block_title text-center mt-5">
            <NuxtLink :to="localePath('/engagement-ring-guide')">Learn more</NuxtLink>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
</script>


<style scoped>
.guide_main {
    padding: 4% 0;
}
.block_title h4{
    font-size: 30px;
}
.block_title p{
    font-weight: 500;
    color: #6a6161;
}
.block_title a{
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 9px 25px;
    width: 250px;
    text-align: center;
    margin-top: 1%;
    border-radius: 4px;
}
.guide_block {
    padding-top: 4%;
    display: flex;
    align-items: flex-start;
}
.guide_box {
    width: 20%;
    padding: 0 2%;
}

.guide_block a{
    color: #000;
    display: inline-block;
}
.guide_block h3{
    color: #000;
    font-size: 18px;
    font-weight: 600;
    padding: 10% 0 5%;
}
.guide_block p{
    color:#6a6161;
    font-size: 16px;
}

@media(max-width: 1024px){
    .guide_block {
        flex-wrap: wrap;
        justify-content: center;
    }
    .guide_box {
        width: 33%;
        padding: 2%;
    }
}
@media(max-width: 992px){
    .block_title p br{
        display: none;
    }
}
@media(max-width: 767px){
    .guide_block h3{
        font-size: 16px;
        padding: 4% 0;
    }
    .guide_block p{
        font-size: 14px;
    }
    .guide_box {
        width: 100%;
        text-align: center;
    }
    .block_title h4{
        font-size: 24px;
    }

    .row.guide_block {
        padding:  5% 0;
        flex-wrap: wrap !important;
    }
    .row.guide_block .col {
        width: 100% !important;
        flex-basis: unset !important;
        text-align: center;
        margin-bottom: 8%;
    }
}
</style>